<template>
  <div>
    <el-table
      :data="dataList"
      :loading="loading"
      style="width: 100%; height: calc(100vh - 357px);"
    >
      <el-table-column prop="htmc" label="续签合同名称" align="center"></el-table-column>
      <el-table-column prop="htbh" label="续签合同编号" align="center"></el-table-column>
      <el-table-column prop="htqsr" label="续签合同起始日" align="center"></el-table-column>
      <el-table-column prop="htzzr" label="续签合同终止日" align="center"></el-table-column>
      <el-table-column prop="xqhtlc" label="续签合同流程" align="center"></el-table-column>
      <el-table-column prop="htje" label="续签合同金额" align="center"></el-table-column>
      <el-table-column prop="zhtmc" label="主合同名称" align="center"></el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions } from 'vuex'

export default {
  components: {
    CrmButton,
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      getInsideContractRenewalList: 'compactInside/getInsideContractRenewalList',
    }),
    // 点击tab发送请求
    queryList() {
      const param = {
        contractId: this.id,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }
      this.getInsideContractRenewalList(param).then(res => {
        this.dataList = res.results
        this.totalCount = res.totalCount
        this.pageNumber = res.pageNumber
        this.pageSize = res.pageSize
      }).catch(e => {
        console.log(e)
      })
    },
    handleSizeChange(value) {
      this.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.pageNumber = value
      this.queryList()
    },
  },
}
</script>
